import {viewport} from '../functions';

jQuery(document).ready(function ($) {
  const el = document.querySelector(".header")
  if(el) {
    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle("is-sticky", e.intersectionRatio < 1),
      { threshold: [1] }
    );

    observer.observe(el);
  }

  $( 'a[href="#"]' ).click(
    function(e) {
      e.preventDefault()
    }
  );

  $('a.newTab, .newTab > a').each(function(index, el) {
    $(this).attr('target', '_blank');
  });

  $('.nav-menu').click(function(e) {
    e.preventDefault()
    $(this).toggleClass('active');
    $('.nav-right').toggleClass('active');
    $('body').toggleClass('u-noScroll');
  });

  $('.nav-sublinksToggle').click(function(e) {
    e.preventDefault()

    $(this).toggleClass('active')
    $(this).siblings('.sublinks, .megamenu').toggleClass('active')
  });

  var link = document.querySelector( ".skipNavigation-link" );

  if (link) {
    link.addEventListener(
      "focus",
      function() {
        link.parentElement.classList.add( "focus" );
      }
    );
    link.addEventListener(
      "blur",
      function() {
          link.parentElement.classList.remove( "focus" );
      }
    );
  }

  $('.nav-link').hover(
    function() {
      $('body').addClass('shadow');
    }, function() {
      $('body').removeClass('shadow');
    }
  );
});